module.exports = __webpack_public_path__ + "media/images/pc/stores/common/appeal_01-34962986bbfd8e5aa154de467162d88c.jpg";